import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { callProcedure } from 'core/classes/helpers/callProcedure'

import { IAssortmentCategory } from '../models/data/IAssortmentCategory'

interface IParams {
  partnerId: string
  programType: ProgramTypes
  fYear: number
}

export const fetchSidebarAssortmentCategories = async ({
  partnerId,
  programType,
  fYear,
}: IParams): Promise<IAssortmentCategory[]> => {
  try {
    const data = await callProcedure('spJBPPlanningSideBarAssortmentSettings', {
      'p.PartnerId': partnerId,
      'p.ProgramType': programType,
      'p.FYear': fYear,
    })
    return data
  } catch (e) {
    return []
  }
}
